const videoList = document.querySelectorAll('.video-element');
const videoDialog = document.querySelector<HTMLDialogElement>('.video-dialog')!;

videoDialog.querySelector('[data-dialog-close]')!.addEventListener('click', () => {
    videoDialog.close();
    document.body.classList.remove('--no-scroll');
    videoDialog.querySelector('[data-dialog-content]')!.innerHTML = '';
});

videoList.forEach(video => {
    const videoLink = video.querySelector<HTMLElement>('[data-video-url]')!;

    videoLink.addEventListener('click', (e) => {
        e.preventDefault();
        const currentVideoID = videoLink.dataset.videoUrl;

        document.body.classList.add('--no-scroll');

        videoDialog.querySelector('[data-dialog-title]')!.innerHTML = video.querySelector('p')!.innerHTML;
        videoDialog.showModal();

        let iframeWidth = videoDialog.offsetWidth - 60;
        let iframeHeight = iframeWidth / 16 * 9;

        if(window.innerWidth < 750) {
            iframeWidth = videoDialog.offsetWidth - 30;
            iframeHeight = iframeWidth / 16 * 9;
        }

        videoDialog.querySelector('[data-dialog-content]')!.innerHTML = `<iframe src="https://www.youtube.com/embed/${currentVideoID}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" width="${iframeWidth}" height="${iframeHeight}" frameborder="0">`;
    });
});
